import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ComparingBannerStyles";
import Disc from "./Disc";

export default class ComparingBanner extends Component {
  render() {
    return (
      <div className={css(styles.bannerWrapper)}>
        <div className={css(styles.discWrapper)}>
          <Disc
            title={"My Home"}
            icon={"/icons/chart-bar.svg"}
            state={"home"}
          />
        </div>
        <span className={css(styles.banner)}>
          <h1 className={css(styles.h1)}>Comparing against...</h1>
          <p className={css(styles.p)}>
            Houses of a similar size and number of occupants.
          </p>
        </span>
      </div>
    );
  }
}
